<template lang="pug">
include /../../s-pug/mixin-icon
figure._flex._flexDirection-column._mb1(v-bind:class="{'Editor-embedWrap': view.editable}")
   img(v-bind:class="{'_mt0': view.editable}" :src="createImagePath({ src, maxWidth: '722' })" :srcset="createImageSrcSet({ src, maxWidth: '722' })" :alt="alt" v-if="src")
   //- ._bg-white._radius._boxShadow2._px1._py075._borderDefault._mx-auto._cursor-default._w100(style="z-index: 500; max-width: 1200px" v-if="!src && view.editable")
   div(v-if="!src && view.editable")
      ._mb05._fs-3._bold Upload image
      ._mb1._c-grey-600._fs-075 JPG or PNG. Upload the largest version possible.
      //- Upload UI
      ._px2._py5._relative._t-center
         ._stretch._radius._border._borderColor-grey-200._border-width2(v-bind:class="dropZoneActive ? '_borderColor-blue-300 _z100' : '_border--dashed'" @drop.prevent="imageOnUpload" @dragenter.prevent="onDragEnter" @dragleave.prevent="onDragLeave" @dragover.prevent)
         Loading(v-if="isUploading")
         ._absoluteCenterXY
            ._mb1._c-grey-500 Drag image
            label._mx-auto
               .Btn.Btn--white.Btn--sm._fs-075 Choose image
               input._alpha-0(style="width: 0; height: 0;" type="file" v-on:change="imageOnUpload($event)" accept=".png, .jpg, .jpeg") 
      //- TODO: Show the in-memory image with a loading indicator over it (perhaps a progress bar, as well)... then replace it with the imgix version after it's uploaded. 
      //-       The goal is to prevent the blank div / jumping that currently happens after an image is uploaded and before it renders from imgix.
   figCaption._c-grey-500._mt05._fs-075(v-if="!view.editable && caption") {{caption}} 
   //- Edit UI
   div(v-if="view.editable")
      ._flex._mt05(v-if="src")
         label._flex._w100._fs-075
            ._flex._flex-justifyFlexEnd._noWrap._flex-alignItemsCenter._border._borderColor-grey-200._radius-left._pl075._pr05._bg-grey-050._cursor-pointer._w100(style="max-width: 90px" v-tippy content="Text that's displayed if the image does not load for some reason. It's considred a best practice to always have image alt text, though it's not strictly required.") 
               | Alt text
               .Editor-helpIcon._ml025: +icon({name: 'icon-help'})
            input.Input.Input--sm._radius-left0._borderLeft-none(@paste.stop type="text" v-model="alt")
      label._flex._w100._fs-075._mt05(v-if="src")
         ._flex._noWrap._flex-alignItemsCenter._border._borderColor-grey-200._radius-left._pl075._pr05._bg-grey-050._cursor-pointer._w100(style="max-width: 90px" v-tippy content="Optional text that will be displayed directly below the image. Useful for providing context.") 
            | Caption
            .Editor-helpIcon._ml025: +icon({name: 'icon-help'})
         input.Input.Input--sm._radius-left0._borderLeft-none(@paste.stop type="text" v-model="caption")
      //- ._flex._mt05
      //-    label._flex._w100._fs-075(style="margin-bottom: -1px")
      //-       ._flex._noWrap._flex-alignItemsCenter._flex-justifyFlexEnd._border._radius-bottom0._borderColor-grey-200._radius-left._px075._bg-grey-050._cursor-pointer._w100(style="max-width: 75px") Alt text
      //-       input.Input.Input--sm._radius-left0._borderLeft-none._radius-bottom0(@paste.stop type="text" v-model="alt")
      //- label._flex._w100._fs-075
      //-    ._flex._noWrap._flex-alignItemsCenter._flex-justifyFlexEnd._border._borderColor-grey-200._radius-top0._radius-left._px075._bg-grey-050._cursor-pointer._w100(style="max-width: 75px") Caption
      //-    input.Input.Input--sm._radius-left0._borderLeft-none._radius-top0(@paste.stop type="text" v-model="caption")
      ._t-right._mt05
         button.Btn.Btn--sm.Btn--white._ml-auto._fs-05(@click.stop.prevent="deleteImage()") Remove{{src ? ' image' : ''}}
</template>

<script>
import uploadFileToStorage from '~/lib/upload-sendFileToStorage'
import getImageUploadAsFile from '~/lib/upload-getImageAsFile'
import { createImagePath, createImageSrcSet } from '~/util'
import { mapState } from 'vuex'

export default {
   props: ['node', 'updateAttrs', 'view', 'getPos'],
   data() {
      return {
         teamProfileSlug: this.$route && this.$route.params.companySlug + '/' + this.$route.params.teamSlug,
         isUploading: false,
         dropZoneActive: false,
      }
   },
   computed: {
      ...mapState(['makerState']),
      src: {
         get() {
            return this.node.attrs.src
         },
         set(src) {
            this.updateAttrs({
               src,
            })
         },
      },
      alt: {
         get() {
            return this.node.attrs.alt
         },
         set(alt) {
            this.updateAttrs({
               alt,
            })
         },
      },
      caption: {
         get() {
            return this.node.attrs.caption
         },
         set(caption) {
            this.updateAttrs({
               caption,
            })
         },
      },
   },
   methods: {
      onDragEnter() {
         this.dropZoneActive = true
      },
      onDragLeave() {
         this.dropZoneActive = false
      },
      imageOnUpload(event) {
         this.isUploading = true
         const teamProfile = this.makerState.teamProfiles.find(teamProfile => teamProfile.data.slug.current === this.teamProfileSlug)
         const file = getImageUploadAsFile(event, teamProfile.ref.id)

         return uploadFileToStorage(file)
            .then(() => {
               this.node.attrs.src = file.nameWithHash
               // var command = this.$refs.jsEditorFloatingMenu.editor.commands.image
               // command({
               //    src: file.nameWithHash,
               //    // 'https://images.unsplash.com/photo-1576521617922-e87d0c35ab44?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=3300&q=80',
               // })
            })
            .finally(() => {
               this.isUploading = false
               this.dropZoneActive = false
            })
      },
      deleteImage() {
         // src: https://github.com/scrumpy/tiptap/issues/231
         // Do a Prosemirror transaction.
         let tr = this.view.state.tr
         let pos = this.getPos()
         tr.delete(pos, pos + this.node.nodeSize)
         this.view.dispatch(tr)
      },
   },
   // mounted() {
   //    console.log('node: ', this.node)
   //    console.log('view: ', this.view)
   // },
}
</script>
